import { TitleCasePipe } from "@angular/common";
import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { MessageService } from "primeng/api";
import { AppMainComponent } from "src/app/app.main.component";
import { ConfigurationService } from "../../../configurationService";
import { ObjectNames, Severity } from "../../constants/constants";
import { CustomService } from "../../custom/custom.service";
import { ListService } from "../../custom/list/list.service";
import data from "../../staticJSON/inventory-template.json";

@Component({
    selector: "app-orders-template",
    templateUrl: "./orders-template.component.html",
    styleUrls: ["./orders-template.component.scss"],
})
export class OrdersTemplateComponent implements OnInit, OnChanges {
    @Input() ordersTemplateTypeId: any;
    @Input() ordersTemplateConfig: any;
    @Input() allOrderTemplates = [];
    @Input() ordersSectionTypeId: any;

    allCustomFieldTypes = [];
    allModules: any = [];
    ordersObjId: any;
    allCustomFields = [];
    customFieldData = [];
    sectionConfig: any;
    allSections = [];
    allSectionsSO = [];
    allSectionsInvoicing = [
        {
            id: 1,
            name: "Billing Address Info",
            labels: [
                {
                    id: 1,
                    labelname: "Account Name",
                    checked: true,
                    sectionId: 1,
                },
                {
                    id: 2,
                    labelname: "Account Street",
                    checked: true,
                    sectionId: 1,
                },
                {
                    id: 3,
                    labelname: "Account Address",
                    checked: true,
                    sectionId: 1,
                },
                {
                    id: 4,
                    labelname: "Account Contact",
                    checked: true,
                    sectionId: 1,
                },
                {
                    id: 5,
                    labelname: "Account Phone",
                    checked: true,
                    sectionId: 1,
                },
            ],
        },
        {
            id: 2,
            name: "Shipping Address Info",
            labels: [
                {
                    id: 1,
                    labelname: "Company Name",
                    checked: true,
                    sectionId: 2,
                },
                {
                    id: 2,
                    labelname: "Company Street",
                    checked: true,
                    sectionId: 2,
                },
                {
                    id: 3,
                    labelname: "Company Address",
                    checked: true,
                    sectionId: 2,
                },
                {
                    id: 4,
                    labelname: "Company Contact",
                    checked: true,
                    sectionId: 2,
                },
                {
                    id: 5,
                    labelname: "Company Phone",
                    checked: true,
                    sectionId: 2,
                },
            ],
        },
        {
            id: 3,
            name: "Misc",
            labels: [
                { id: 1, labelname: "Date", checked: true, sectionId: 3 },
                {
                    id: 2,
                    labelname: "Invoicing No.",
                    checked: true,
                    sectionId: 3,
                },
                { id: 3, labelname: "Status", checked: true, sectionId: 3 },
                { id: 4, labelname: "Created By", checked: true, sectionId: 3 },
                {
                    id: 5,
                    labelname: "Reference No.",
                    checked: false,
                    sectionId: 3,
                },
            ],
        },
        {
            id: 4,
            name: "Section",
            labels: [
                {
                    id: 1,
                    labelname: "Payment Method",
                    checked: true,
                    sectionId: 4,
                },
                {
                    id: 2,
                    labelname: "Payment Term",
                    checked: true,
                    sectionId: 4,
                },
                {
                    id: 3,
                    labelname: "Shipping Method",
                    checked: true,
                    sectionId: 4,
                },
                {
                    id: 4,
                    labelname: "Shipping Term",
                    checked: true,
                    sectionId: 4,
                },
            ],
        },
        {
            id: 5,
            name: "Table",
            labels: [
                { id: 1, labelname: "Item", checked: true, sectionId: 5 },
                {
                    id: 2,
                    labelname: "Description",
                    checked: true,
                    sectionId: 5,
                },
                { id: 3, labelname: "Qty", checked: true, sectionId: 5 },
                { id: 4, labelname: "UOM", checked: true, sectionId: 5 },
                { id: 5, labelname: "Rate", checked: true, sectionId: 5 },
                { id: 6, labelname: "Amount", checked: true, sectionId: 5 },
            ],
        },
        {
            id: 6,
            name: "Footer",
            labels: [
                { id: 1, labelname: "SubTotal", checked: true, sectionId: 6 },
                { id: 2, labelname: "Shipping", checked: true, sectionId: 6 },
                { id: 3, labelname: "Tax", checked: true, sectionId: 6 },
                { id: 4, labelname: "Discount", checked: true, sectionId: 6 },
                {
                    id: 5,
                    labelname: "Other Total",
                    checked: true,
                    sectionId: 6,
                },
            ],
        },
        {
            id: 7,
            name: "Message",
            labels: [
                {
                    id: 1,
                    labelname: "Vendor Message",
                    checked: true,
                    sectionId: 7,
                },
                { id: 2, labelname: "Memo", checked: true, sectionId: 7 },
            ],
        },
    ];
    templateHeader = "";
    templateSOTemp = data;
    displayEditSOTemplate = false;
    displayAddNewField = false;
    fieldTypes = [
        {
            id: 1,
            labelname: "Field 1",
            checked: false,
            movable: true,
            default: false,
        },
        {
            id: 2,
            labelname: "Field 2",
            checked: false,
            movable: true,
            default: false,
        },
        {
            id: 3,
            labelname: "Field 3",
            checked: false,
            movable: true,
            default: false,
        },
        {
            id: 4,
            labelname: "Field 4",
            checked: false,
            movable: true,
            default: false,
        },
    ];
    fieldTypesDD = [];
    tempField;
    index;
    selectedFieldType;
    checkLength = 0;
    maxNo = false;
    maxSectionNo = false;

    constructor(
        private app: AppMainComponent,
        private service: ConfigurationService,
        private customService: CustomService,
        private customfieldService: ListService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.ordersTemplateTypeId && changes.ordersTemplateTypeId.currentValue) {
            this.loadFields();
        }
    }

    ngOnInit(): void {
        // this.loadFields();
    }

    loadFields() {
        this.customService.getCustom().subscribe((field) => {
            this.getModules();
            this.loadConfigurations();
        });
    }

    getModules() {
        this.allModules = [];
        this.customfieldService.getAllModules().subscribe((modules) => {
            this.allModules = modules;
            const obj = this.allModules.filter((obj) => obj.name == ObjectNames.OrdersConstants.ordersFieldName)[0];
            this.ordersObjId = obj.id;
            this.getCustomFieldTypes(obj.id);
        });
    }

    getCustomFieldTypes(objectId) {
        this.allCustomFieldTypes = [];
        this.customfieldService.getAllCustomFieldTypes(objectId).then((fldtyps) => {
            this.allCustomFieldTypes = fldtyps;
            this.loadCustomFields();
        });
    }

    loadCustomFields() {
        this.customFieldData = [];
        this.allCustomFields = [];

        this.customfieldService.getAllCustomFields(this.ordersObjId).then((fields) => {
            if (fields && fields.length > 0) {
                for (let l of fields) {
                    let eachRecord = {
                        id: Number(l.id + ""),
                        name: l.name,
                        module: this.allModules.find((el) => el.id == l.objectId)?.name,
                        formControl: this.allCustomFieldTypes.find((el) => el.id == l.formControlId)?.name,
                        isRequired: l.isRequired,
                        statusId: l.statusId,
                        statusName: l.status?.name,
                        section: l.section,
                        configurationId: l.configurationId,
                        isEdit: l.isEdit,
                        isDelete: l.isDelete,
                        custom: true,
                        formControlId: l.formControlId,
                    };
                    this.customFieldData.push(eachRecord);
                }
            }
            this.allCustomFields = this.customFieldData;
        });
    }

    loadConfigurations() {
        this.allOrderTemplates = [];
        this.allSections = [];

        this.service.getConfigurationsByModuleName("order").subscribe((configs) => {
            //templates
            this.ordersTemplateConfig = configs?.filter((s) => s.name == ObjectNames.OrdersConstants.Orders_Template_Object && s.typeId == this.ordersTemplateTypeId)[0];
            if (this.ordersTemplateConfig) {
                this.allOrderTemplates = JSON.parse(this.ordersTemplateConfig?.configurationDetails[0].configJSONValue);
            }

            //sections
            this.sectionConfig = configs?.filter((s) => s.name == ObjectNames.customConstants.Order_Section_Object && s.typeId == this.ordersSectionTypeId)[0];
            if (this.sectionConfig) {
                this.allSections = JSON.parse(this.sectionConfig.configurationDetails[0].configJSONValue);
                this.allSections?.forEach((element) => {
                    element.isSelect = true;
                });
            }
        });
    }

    showEditOrderTemplate(c) {
        this.templateSOTemp = [];
        this.allSectionsSO = [];
        this.templateSOTemp = c;
        this.templateSOTemp.labels = [];

        if (c.type.name == "Sales Orders" || c.type.name == "Estimates" || c.type.name == "Invoicing") {
            this.allSectionsSO = this.allSections.filter(
                (s) => s.typeId == 0, // typeId = 0 for combined templates estimates, salesorder and invoice
            );
        } else {
            this.allSectionsSO = this.allSections.filter((s) => s.typeId == c.typeId);
        }

        this.allSectionsSO.forEach((element) => {
            element["labels"] = [];
            const data = this.templateSOTemp[element.code.trim()];
            if (data && data.length > 0) {
                data.forEach((d) => {
                    if (!d.custom) {
                        element["labels"].push(d);
                    } else {
                        const customFields = this.allCustomFields.filter((s) => s.section.id == element.id);
                        if (customFields && customFields.length > 0) {
                            const exists = customFields.find((l) => l.id == d.id && l.name == d.code);
                            if (exists) {
                                element["labels"].push(d);
                            }
                        }
                    }
                });
            }

            const customFields = this.allCustomFields.filter((s) => s.section.id == element.id);
            if (customFields && customFields.length > 0) {
                customFields.forEach((fld) => {
                    const exists = element.labels.find((l) => l.id == fld.id && l.code == fld.name);
                    if (!exists) {
                        let temp = {};
                        if (fld.isEdit) {
                            temp = {
                                code: fld.name,
                                id: fld.id,
                                IsPick: false,
                                IsPack: false,
                                IsPrint: false,
                                isChecked: false,
                                isMovable: true,
                                isShowForDrag: true,
                                labelname: fld.name,
                                name: fld.name,
                                sectionId: fld.section.id,
                                formControl: fld.formControl,
                                typeId: fld.section.typeId,
                                custom: true,
                                formControlId: fld.formControlId,
                            };
                            element["labels"].push(temp);
                        }
                    }
                });
            }
        });

        // section length check
        this.allSectionsSO.forEach((element) => {
            if (element.code == "labels_section") {
                let lengthCheck = 0;
                for (let child of element.labels) {
                    if (child.isChecked) {
                        lengthCheck++;
                    }
                }
                this.maxSectionNo = lengthCheck >= 5;
            }
        });

        this.templateHeader = c.type.name;
        this.displayEditSOTemplate = true;
    }

    showSection(section) {
        const fieldsAvailable = this.templateSOTemp.labels.filter((s) => s.sectionId == section.id);
        if (fieldsAvailable.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    updateSOTemplate(template, sections) {
        if (sections && sections.length > 0) {
            sections.forEach((s) => {
                if (s && s.code && template[s.code]) {
                    template[s.code] = [];
                    template[s.code] = s.labels;
                }
            });
        }
        this.updateSOTemplateData(template);
    }

    updateSOTemplateData(template) {
        this.templateSOTemp = template;
        this.templateSOTemp.updatedDate = new Date().toISOString();
        this.templateSOTemp.updatedBy = this.app.userId;
        this.templateSOTemp.updatedSource = this.app.userIP;

        this.allOrderTemplates.forEach((element) => {
            if (template.id == element.id) {
                element = this.templateSOTemp;
            }
        });
        this.ordersTemplateConfig.configJSONValue = JSON.stringify(this.allOrderTemplates);
        this.service
            .updateConfiguration(this.ordersTemplateConfig)
            .then(() => {
                this.messageService.add({
                    severity: Severity.Success,
                    summary: this.titlecasePipe.transform(Severity.Success),
                    detail: "Template updated successfully...",
                });
                this.displayEditSOTemplate = false;
                this.loadConfigurations();
            })
            .catch(() => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred while saving data...",
                });
            });
    }

    addNewField(c) {
        this.selectedFieldType = null;
        this.tempField = JSON.parse(JSON.stringify(c));
        this.fieldTypesDD = JSON.parse(JSON.stringify(this.fieldTypes));
        this.displayAddNewField = true;
    }

    saveField(c) {
        this.fieldTypes = this.fieldTypes.filter((e) => e.id != this.selectedFieldType.id);
        this.selectedFieldType.id = this.allSectionsSO.filter((ele) => ele.id == c.id)[0].label.length + 1;
        this.allSectionsSO.filter((ele) => ele.id == c.id)[0].label.push(this.selectedFieldType);
        this.displayAddNewField = false;
    }

    removeNewField(c, l) {
        if (!l.isChecked) {
            let i = this.allSectionsSO.filter((ele) => ele.id == c.id)[0].label.indexOf(l);
            this.allSectionsSO.filter((ele) => ele.id == c.id)[0].label.splice(i, 1);
            this.fieldTypes.push(l);
        }
    }

    checkMax(section, isChecked: boolean) {
        this.checkLength = 0;
        for (let child of section.labels) {
            if (child.isChecked) {
                this.checkLength++;
            }
        }
        if (isChecked) {
            this.checkLength++;
        } else {
            this.checkLength--;
        }
        this.maxNo = this.checkLength >= 3;
    }

    checkSectionMax(section, isChecked: boolean) {
        let lengthCheck = 0;
        for (let child of section.labels) {
            if (child.isChecked) {
                lengthCheck++;
            }
        }
        if (isChecked) {
            lengthCheck++;
        } else {
            lengthCheck--;
        }
        this.maxSectionNo = lengthCheck >= 4;
    }
}
